export class ParticipantMember {
    ordinal: number;
    active: boolean;
    participant_id: number;
    participant_name: string;
    participant_type: string;
    duration: number;
}
